module.exports = __webpack_public_path__ + "img/lo-tit.png";